import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ReferralService} from '../../../shared/services/referral.service';

export const REFERRAL_TABS = [
    {path: 'dashboard', title: 'Referral dashboard', short: 'Dashboard', icon: 'fas fa-chart-pie'},
    {path: 'partners', title: 'Referral partners', short: 'Partners', icon: 'fas fa-users'},
    {path: 'referrals', title: 'Referrals', short: 'Referrals', icon: 'fas fa-user-plus', badge: 'unassigned'},
    {path: 'payouts', title: 'Payouts', short: 'Payouts', icon: 'fas fa-rupee-sign', badge: 'pendingPayouts'},
    {path: 'kyc', title: 'KYC requests', short: 'KYC requests', icon: 'fas fa-id-card', badge: 'pendingKyc'},
    {path: 'payout-accounts', title: 'Payout account verification', short: 'Payout accounts', icon: 'fas fa-university', badge: 'pendingPayoutAccounts'},
    {path: 'programs', title: 'Programs & rewards', short: 'Programs & rewards', icon: 'fas fa-gift'},
    {path: 'campaigns', title: 'Campaigns', short: 'Campaigns', icon: 'fas fa-bullhorn'}
];

/** Wraps every referral program page: breadcrumb, tabs and the shared stylesheet. */
@Component({
    selector: 'app-referral-shell',
    templateUrl: './referral-shell.component.html',
    styleUrls: ['./referral-shell.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ReferralShellComponent implements OnInit, OnDestroy {
    tabs = REFERRAL_TABS;
    current = REFERRAL_TABS[0];
    counts = {unassigned: 0, pendingPayouts: 0, pendingKyc: 0, pendingPayoutAccounts: 0};
    private subs: Subscription[] = [];

    constructor(private router: Router, private referralService: ReferralService) {
    }

    ngOnInit() {
        this.syncTitle();
        this.refreshCounts();
        this.subs.push(
            this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.syncTitle()),
            this.referralService.changed.subscribe(() => this.refreshCounts())
        );
    }

    private refreshCounts() {
        this.subs.push(this.referralService.counts().subscribe(counts => this.counts = counts));
    }

    get totalPending(): number {
        return this.counts.unassigned + this.counts.pendingPayouts + this.counts.pendingKyc + this.counts.pendingPayoutAccounts;
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    private syncTitle() {
        const seg = this.router.url.split('?')[0].split('/')[2];
        this.current = this.tabs.find(t => t.path === seg) || this.tabs[0];
    }
}
